import {
  getErRepresentasjon,
  getErRepresentasjonViaFullmakt,
} from "@helsenorge/framework-utils/hn-user";

export const getSkjulOppgave = (
  skjulForFullmakt: boolean | undefined,
): boolean => {
  return (
    getErRepresentasjon() === true &&
    getErRepresentasjonViaFullmakt() === false &&
    skjulForFullmakt === true
  );
};
